import { z } from 'zod'
import { authFetch } from './authFetch'

const getOriginLoanDataSchema = z.record(z.unknown()).optional().default({})

const getOriginSchema = z.object({
  borrowerDisplayName: z.string().nullable().default(''),
  loanNumber: z.string(),
  entityId: z.string(),
  missingFields: z.array(z.object({ description: z.string() })).optional(),
  loan: getOriginLoanDataSchema, // Is this optional? or have a default value?
})
const getOrigin = async (originId: string, partnerAccessToken: string) => {
  const response = await authFetch(
    `/api/encompass/origins/${originId}?partner_access_token=${partnerAccessToken}`
  )

  if (response.ok) {
    const data = (await response.json()) as { success: boolean }
    // When fetch throws an error
    if (data.success === false) {
      return undefined
    }
    const parsed = getOriginSchema.parse(data)
    return parsed
  }

  const errorMessage =
    ((await response.json()) as { error?: string }).error ||
    'Unknown error with getOrigin'

  if (response.status === 404) {
    return { message: '404', statusText: errorMessage }
  }
  if (response.status === 403) {
    return { message: '403', statusText: errorMessage }
  }

  // Handle other error status codes
  return { message: response.status.toString(), statusText: errorMessage }
}

export { getOrigin }
